export default __webpack_public_path__ + "e5d4bbf1f3099cb4da7dff44734db3b0.svg";